var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-topEn__memberList"},[_vm._l((_vm.params),function(m,i){return [_c('en-member-slide',{attrs:{"member":m}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }